import { makeVar } from '@apollo/client';

const data = {
  nodeId: null,
  nodeCategory: null,
  nodeHierarchy: null,
  singleSelection: null
};

export const partnerAssociationModalStateVar = makeVar({ open: false, data: data });
